<script setup lang="ts">
import { IFieldRefs } from "@/core/libs/FormRequester/types/IFieldRefs.ts";
import InputCheckbox from "@/components/form/InputCheckbox.vue";
import { TextInput } from "@/components/form/index.ts";
import { IStringArray } from "@/interfaces/IStringArray.ts";
import InputSelect from "@/components/form/InputSelect.vue";
import Countries from "@/libs/core/countries.ts";
import { IObjectArray } from "@/interfaces/IObjectArray.ts";
import { Icon } from "@iconify/vue";

type ICountry = {
  code: string,
  code3: string,
  name: string,
  number: string,
}

const countries: IObjectArray<ICountry> = {};

for (const i in Countries) {
  const country = Countries[i];
  countries[country.code3] = country;
}

type IProps = {
  type: "text" | "select" | "textarea" | "checkbox" | "number" | "date" | "country",
  name: string,
  label?: string,
  model: IFieldRefs,
  values?: IStringArray,
}
const props = withDefaults(defineProps<IProps>(), {
  type: "text",
  label: "",
  values: () => ({})
});

const {
  model: fieldModel,
  isError: fieldIsError,
  errors: fieldErrors,
  isDisabled: fieldIsDisabled
} = props.model;

</script>

<template>
  <InputCheckbox
    v-if="props.type === 'checkbox'"
    v-bind="$props"
    v-model="fieldModel"
    :is-error="fieldIsError"
    :errors="fieldErrors"
    :disabled="fieldIsDisabled">
    <slot />
  </InputCheckbox>

  <TextInput
    v-else-if="props.type === 'text'"
    v-bind="$props"
    v-model="fieldModel"
    :is-error="fieldIsError"
    :errors="fieldErrors"
    :disabled="fieldIsDisabled" />

  <InputSelect
    v-else-if="props.type === 'select'"
    :list="props.values"
    v-bind="$props"
    v-model="fieldModel"
    :is-error="fieldIsError"
    :errors="fieldErrors"
    :disabled="fieldIsDisabled"
  />

  <TextInput
    dateFormat="DD MMMM YYYY"
    v-else-if="props.type === 'date'"
    v-bind="{...$props, type: 'date'}"
    v-model="fieldModel"
    :is-error="fieldIsError"
    :errors="fieldErrors"
    :disabled="fieldIsDisabled" />

  <InputSelect
    v-else-if="props.type === 'country'"
    :list="countries"
    v-bind="$props"
    v-model="fieldModel"
    :is-error="fieldIsError"
    :errors="fieldErrors"
    :disabled="fieldIsDisabled"
  >

    <template #selected="{ item }">
      <div class="flex items-center gap-3">
        <Icon v-if="item" :icon="'flagpack:' + (item as any).code.toLowerCase()" width="32" height="24" />
        <span v-if="item">{{ (item as any).name }}</span>
      </div>
    </template>

    <template #item="{ item }">
      <Icon :icon="'flagpack:' + (item as any).code.toLowerCase()" width="32" height="24" />
      <span class="ml-3 block truncate"
            :class="{'font-normal': !(item as any).isSelected,'font-semibold': (item as any).isSelected}"
      >
        {{ (item as any).name }}
      </span>
    </template>
  </InputSelect>
</template>

<style scoped lang="scss">

</style>
